import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../theming/contexts/ThemeContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { PrimaryMessageContentSectionWrapper } from './PrimaryMessageContentSection';
import { useAccessibilityContext } from '../../accessibility/AccessibilityContext';
import { OBSIDIAN, HEFFALUMP } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageContentWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContent__PrimaryMessageContentWrapper",
  componentId: "sc-1f0klg8-0"
})(["position:relative;min-height:32px;word-break:break-word;box-sizing:border-box;background-color:", ";color:", ";display:inline-flex;align-items:", ";flex-direction:column;border-radius:10px;", "{&:first-child{border-top:none;}}max-width:max(calc(100% - 48px),284px);float:", ";time{float:", ";color:", ";}"], ({
  backgroundColor
}) => backgroundColor, ({
  textColor
}) => textColor, ({
  alignItems
}) => alignItems, PrimaryMessageContentSectionWrapper, ({
  alignItems
}) => alignItems === 'flex-end' ? 'right' : '', ({
  alignItems
}) => alignItems === 'flex-end' ? 'right' : 'left', ({
  textColor
}) => textColor === HEFFALUMP ? OBSIDIAN : textColor);
const PrimaryMessageContent = props => {
  const {
    children,
    className,
    shouldFocusMessage,
    style
  } = props;
  const theme = useTheme();
  const {
    backgroundColor,
    borderColor,
    borderWidth,
    textColor,
    alignItems
  } = theme;
  const ref = useRef(null);
  const {
    disableAutoFocus
  } = useAccessibilityContext();
  useEffect(() => {
    if (!disableAutoFocus && shouldFocusMessage && ref.current) {
      ref.current.focus();
    }
  }, [disableAutoFocus, shouldFocusMessage]);
  return /*#__PURE__*/_jsx(PrimaryMessageContentWrapper, {
    className: className,
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderWidth: borderWidth,
    alignItems: alignItems,
    tabIndex: 0,
    ref: ref,
    textColor: textColor,
    style: style,
    "data-test-id": "primary-message-content-wrapper",
    children: children
  });
};
PrimaryMessageContent.displayName = 'PrimaryMessageContent';
PrimaryMessageContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  shouldFocusMessage: PropTypes.bool
};
export default PrimaryMessageContent;